import Chart from 'chart.js/auto';
import pattern from 'patternomaly';

function getCSSCustomProperty(prop) {
  return getComputedStyle(document.documentElement).getPropertyValue(prop).trim();
}

function transpose(matrix) {
  return matrix[0].map((_, i) => matrix.map(row => row[i]));
}

function initVerticalCharts() {
  document.querySelectorAll('.vertical-chart').forEach(canvas => {
    if (canvas.chart) {
      canvas.chart.destroy();
    }

    const ctx = canvas.getContext('2d');
    const parent = canvas.parentElement;

    const size = Math.min(parent.clientWidth, 600);
    canvas.width = size;
    canvas.height = size;

    const chartLabels = (canvas.dataset.labels || '').split(',').map(s => s.trim());
    let chartData = JSON.parse(canvas.dataset.values.replace(/'/g, '"'));
    const valueNames = (canvas.dataset.valuesNames || '').split(',').map(name => name.trim());

    chartData = transpose(chartData);

    const datasets = chartData.map((data, i) => ({
      label: valueNames[i] || `Valeur ${i + 1}`,
      data,
      backgroundColor: i === 0 ? '#3E2881' : '#E32257',
      borderColor: 'black',
      borderWidth: 2,
      borderRadius: 6
    }));

    canvas.chart = new Chart(ctx, {
      type: 'bar',
      data: {
        labels: chartLabels,
        datasets: datasets
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        layout: {
          padding: {
            bottom: Math.min(size / 10, 40)
          }
        },
        scales: {
          x: {
            grid: { display: false },
            ticks: {
              color: 'black',
              font: {
                family: getCSSCustomProperty('--font-family') || 'sans-serif',
                size: Math.min(size / 25, 16),
                weight: '400',
              },
              padding: 8
            }
          },
          y: {
            beginAtZero: true,
            grid: { color: '#ddd' },
            ticks: {
              color: 'black',
              font: {
                family: getCSSCustomProperty('--font-family') || 'sans-serif',
                size: Math.min(size / 25, 16),
                weight: '400',
              },
              padding: 8
            }
          }
        },
        plugins: {
          legend: {
            display: true,
            position: 'bottom',
            labels: {
              color: 'black',
              font: {
                family: getCSSCustomProperty('--font-family') || 'sans-serif',
                size: Math.min(size / 25, 16),
                weight: '400',
              },
              padding: 30,
              usePointStyle: true,
              pointStyle: 'circle',
              verticalAlign: 'bottom',
              boxHeight: 20,
              borderRadius: 6
            }
          },
          tooltip: {
            enabled: false,
          },
        },
        hover: { mode: null },
        interaction: {
          mode: null,
          intersect: false,
          events: []
        }
      }
    });
  });
}

window.addEventListener('load', initVerticalCharts);
window.addEventListener('resize', debounce(initVerticalCharts, 100));

function debounce(func, wait) {
  let timeout;
  return function () {
    const context = this, args = arguments;
    clearTimeout(timeout);
    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}
